import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import Check from 'react-icons/lib/fa/check'

import Text from '../Text'
import Loading from '../Loading'
import Table from '../Table'
import Badge from '../Badge'

import { convertRole, formatPhoneNumber } from '../../utils/strings'

export const GET_USERS = gql`
  {
    users {
      id
      emailAddress
      firstName
      lastName
      role
      phoneNumber
      authId
    }
  }
`

const columns = [
  {Header: 'First Name', accessor: 'firstName', width: 120},
  {Header: 'Last Name', accessor: 'lastName', width: 120},
  {Header: 'Email Address', accessor: 'emailAddress', width: 220},
  {Header: 'Phone Number', accessor: 'phoneNumber', width: 150,
    Cell: ({value}) =>
      formatPhoneNumber(value)
  },
  {
    Header: 'Role', accessor: 'role', width: 120,
    Cell: ({value}) =>
      <Badge secondary>{convertRole(value)}</Badge>,
    filterMethod: ({value, id}, row) =>
      value === 'ALL' ? true : value === row[id],
    Filter: ({filter, onChange}) =>
      <select
        onChange={event => onChange(event.target.value)}
        style={{width: '100%', height: 28}}
        value={filter ? filter.value : 'ALL'}>
        <option value='ALL'>--</option>
        <option value='ADMIN'>Admin</option>
        <option value='SALES'>Sales Rep</option>
        <option value='CLIENT'>Client</option>
      </select>
  },
  {
    Header: 'Can Login?', accessor: 'authId', width: 90, style: {textAlign: 'center'},
    Cell: ({value}) =>
      value ? <Check style={{fill: 'green'}} /> : '',
    filterMethod: ({value, id}, row) =>
      value === 'ALL' ? true : (value === 'YES' && !!row[id]) || (value === 'NO' && !row[id]),
    Filter: ({filter, onChange}) =>
      <select
        onChange={event => onChange(event.target.value)}
        style={{width: '100%', height: 28}}
        value={filter ? filter.value : 'ALL'}>
        <option value='ALL'>--</option>
        <option value='YES'>Yes</option>
        <option value='NO'>No</option>
      </select>
  }
]

const List = ({onRowClick, filterable}) =>
  <Query query={GET_USERS} fetchPolicy='cache-and-network'>
    {({loading, error, data}) => {
      if (error) return <Text error>{error.message}</Text>

      return (
        <React.Fragment>
          {loading && <Loading />}
          <Table
            filterable={filterable}
            noDataText={!loading && 'No users found!'}
            loading={loading}
            data={data.users}
            columns={columns}
            onRowClick={onRowClick}
          />
        </React.Fragment>
      )
    }}
  </Query>

export default List


// WEBPACK FOOTER //
// ./src/components/Users/List.js